<template>
  <app-timeline>
    <app-timeline-item
      v-for="history_item in history"
      :key="history_item.id"
    >
      <div class="d-flex justify-content-between">
        <div>
          <div>{{ $_dateTimeFormatter(history_item.updated_at).split(',')[0] }}</div>
          <div>{{ history_item.author }}</div>
        </div>
        <div>
          <!-- <b-button
            class="px-75 mr-1"
            variant="info"
            @click="$emit('showClicked', history_item)"
          >
            <feather-icon icon="EyeIcon" />
          </b-button> -->
          <!-- <b-button
            class="px-75"
            variant="warning"
            @click="$emit('revertClicked', history_item.id)"
          >
            <feather-icon icon="CornerUpLeftIcon" />
          </b-button> -->
        </div>
      </div>
    </app-timeline-item>
  </app-timeline>
</template>

<script>
// import { BButton } from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import formatters from '@/mixins/extra'

export default {
  components: {
    AppTimelineItem,
    AppTimeline,
    // BButton,
  },
  mixins: [formatters],
  props: {
    history: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style>

</style>
